import type { RxInput } from '~/api/graphql/generated/types'
import type { Prescription } from '~/types/entities/prescriptions'
import {
  convertOrderToRxInput,
  getPrescriptionAutoshipFrequency,
  getPrescriptionAutoshipUnitId,
} from '~/utils/prescription'

export const sanitizePrescriptionForSwap = (
  prescription: Prescription,
): Prescription => {
  const { id, createdAt, updatedAt, deleted, rxNo, prescribedDate, ...rest } =
    prescription
  return rest as Prescription
}

export const convertPrescriptionToRxInputForSwap = (
  prescription: Prescription,
  isFoodCatalogEnabled: boolean,
): RxInput => {
  const autoshipUnitId = getPrescriptionAutoshipUnitId(prescription)
  const autoshipFrequency = getPrescriptionAutoshipFrequency(prescription)

  return convertOrderToRxInput(
    prescription,
    isFoodCatalogEnabled,
    autoshipUnitId,
    autoshipFrequency,
  )
}
